import React from 'react';
import './Chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter6() {
  const hyperlinkData = [
    {
      href: 'https://ir.allogene.com/news-releases/news-release-details/allogene-therapeutics-initiates-industrys-first-allogeneic-car-t',
      copy: 'launched'
    }
  ];
  return (
    <section className="chapter">
      <p className="chapter-paragraph">
        Allogene recently <Hyperlink hyperlinkData={hyperlinkData[0]} /> the industry’s first Phase
        2 clinical trial of an allogeneic CAR T at a number of cancer centers in the U.S. These
        clinical trial sites are now able to provide this investigational treatment to eligible
        patients, including those who are unable to gain access to autologous CAR T. Success in
        these clinical trials could support FDA approval and increase the options for patients in
        ways never before possible.
      </p>
      <p className="chapter-paragraph">
        “It has been the most amazing five years in the field of hematology care with the advent of
        CAR T cell therapy,” says Dr. Michael Tees, Associate Member Physician and Director of the
        Lymphoma Program at the Colorado Blood Cancer Institute in Denver, Colorado. “The ability to
        genetically re-engineer a patient’s own immune cells—and now someone else’s immune cells—in
        order to harness the power of immunotherapy to kill cancer is something that few thought
        would ever be possible.”
      </p>
    </section>
  );
}

export default Chapter6;
